<div class="row" *ngIf="organization">
  <div class="col-lg-12">
    <div class="grid">
      <p class="grid-header">Edit Organization</p>
      <div class="grid-body">
        <div class="item-wrapper">
          <form>
            <div class="form-group">
              <label for="name">Name</label>
              <input [(ngModel)]="organization.name" name="first_name" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label for="phone">Phone Number</label>
              <input [(ngModel)]="organization.phone" name="phone" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label for="address1">Address 1</label>
              <input [(ngModel)]="organization.address1" name="address1" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label for="address2">Address 2</label>
              <input [(ngModel)]="organization.address2" name="address2" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label for="city">City</label>
              <input [(ngModel)]="organization.city" name="city" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label for="province">State/Province</label>
              <input [(ngModel)]="organization.province" name="province" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label for="zip">Zip Code</label>
              <input [(ngModel)]="organization.zip" name="zip" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label for="country">Country</label>
              <input [(ngModel)]="organization.country" name="country" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label for="hologram_org_id">Hologram Org ID</label>
              <input [(ngModel)]="organization.hologram_org_id" name="hologram_org_id" type="text" class="form-control"/>
            </div>
            <div class="form-group custom-file">
              <label for="logo" class="custom-file-label">Logo</label>
              <input type="file" name="logo" class="custom-file-input" (change)="uploadLogo($event)" />
              <img *ngIf="logo" class="org-logo" [src]="logo" />
              <img *ngIf="!logo" class="org-logo" [src]="organization.logo_storage_url" />
            </div>
            <div class="form-group">
              <button (click)="submitForm()" type="submit" class="btn btn-sm btn-primary">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
